<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Ento Withdrawal
      </h2>
      <p class="tw-italic tw-text-gray-700">
        Approve for Ento Withdrawal Request Form
      </p>
    </b-container>

    <b-container fluid class="tw-my-5">
      <b-row>
        <b-col lg="4"></b-col>
        <b-col lg="4"></b-col>
        <b-col lg="4">
          <b-form-group
          label=""
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        </b-col>
      </b-row>
    </b-container>
    <hr>

     <b-card no-body v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
        <b-tabs card fill>
          <b-tab :title="'NEW REQUESTS ('+new_requests_count+')'" active v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
            <b-card-text >
              <b-table striped hover :fields="new_requests_fields" :items="new_requests_items" :filter="filter">
                <template v-slot:cell(name)="data">
                    <b-link :href="data.item.case_link" target="_blank">{{ data.item.name }}</b-link>
                </template>

                <template v-slot:cell(approve)="data">
                  <div v-if="show_buttons">
                    <b-button
                      @click="approve(data.index)"
                      size="sm"
                      variant="success"
                      class="w-20"
                    >
                      Approve
                    </b-button>
                    <b-button
                      @click="decline(data.index)"
                      size="sm"
                      variant="danger"
                      class="w-20 ml-2"
                    >
                      Decline
                    </b-button>
                  </div>
                  <div else>
                    <!-- <b-alert v-if="show_loading" variant="info" show>Processing... <i class="fas fa-spin fa-spinner"></i></b-alert> -->
                    <div v-if="show_loading">Processing... <i class="fas fa-spin fa-spinner"></i></div>
                  </div>
                </template>

                <template v-slot:cell(withdrawal_form)="data">
                  <div>Ento</div>
                </template>

              </b-table>
            </b-card-text>
          </b-tab>

          <b-tab :title="'COMPLETED REQUESTS ('+completed_requests_count+')'" v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
            <b-card-text >

              <b-table striped hover :fields="completed_requests_fields" :items="completed_requests_items" :filter="filter">
                <template v-slot:cell(name)="data">
                  <b-link :href="data.item.case_link" target="_blank">{{ data.item.name }}</b-link>
                </template>
                <template v-slot:cell(approve)="data">
                  {{data.item.ento_withdrawal_approved}}
                </template>
                <template v-slot:cell(withdrawal_form)="data">
                  <div>Ento</div>
                </template>
              </b-table>
            </b-card-text>
          </b-tab>
        </b-tabs>
     </b-card>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapState, mapGetters } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      new_requests_fields: [
        { key: "compound_id", label: "Name" },
        { key: "village", label: "Village" },
        { key: "ento_withdrawal_reason", label: "Reason" },
        { key: "ento_withdrawal_request_date", label: "Date"},
        { key: "withdrawal_form", label: "Withdrawal Form"},
        { key: "approve", label: "Approve for Final Status"},
      ],

      completed_requests_fields: [
        { key: "compound_id", label: "Name" },
        { key: "village", label: "Village" },
        { key: "ento_withdrawal_reason", label: "Reason" },
        { key: "ento_withdrawal_request_date", label: "Date"},
        { key: "withdrawal_form", label: "Withdrawal Form"},
        { key: "approve", label: "Status"},
      ],
      new_requests_items: [],
      completed_requests_items: [],
      componentKey: 0,
      filter: null,
      show_buttons: true,
      show_loading: false,
      new_requests_count: 0,
      completed_requests_count: 0,
    };
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    ...mapGetters('user', ['inMyGroups'])
  },
  mounted: function() {
    this.new_request();
    this.completed_request();
  },
  methods: {
    new_request: function() {
      let that = this;
      HTTP.get("/srilanka/ento_withdrawal/get_new").then(response => {
        that.new_requests_items = response.data;
        that.new_requests_count = that.new_requests_items.length;
      }).catch((error) => {
        HandleErrors.HandleErrors(error);
      }).then(() => {
        that.show_loading = false;
        that.show_buttons = true;
      });
    },
    completed_request: function() {
      let that = this;
      HTTP.get("/srilanka/ento_withdrawal/get_completed").then(response => {
        that.completed_requests_items = response.data;
        that.completed_requests_count = that.completed_requests_items.length;
      });
    },
    approve: function(index){
      let that = this;
      that.show_buttons = false;
      that.show_loading = true;
      HTTP.post("/srilanka/ento_withdrawal/"+that.new_requests_items[index].id+"/", {
        status: 'approve'
      }).then(response => {
          that.new_request();
          that.completed_request();
      });
    },
    decline: function(index){
      let that = this;
      that.show_buttons = false;
      that.show_loading = true;
      HTTP.post("/srilanka/ento_withdrawal/"+that.new_requests_items[index].id+"/", {
        status: 'decline'
      }).then(response => {
        that.new_request();
        that.completed_request();
      });
    }
  }
};
</script>

<style>
</style>